export default "a92f73b3f8ba98ad.ttf"